(() => {
  const apiTimers = {};

  const user = {
    login() {
      window.swinger.storage.set('swinger.user.authenticated', true);

      if (window.swinger.eventHub) {
        window.swinger.eventHub.trigger(document, 'swinger.user:authchange');
      }
    },
    logout() {
      window.swinger.storage.clear();

      if (window.swinger.eventHub) {
        window.swinger.eventHub.trigger(document, 'swinger.user:authchange');
      }
    },
    getPoints() {
      const me = window.swinger.storage.get('me') || {};

      if (me.points && me.points.available) {
        return me.points.available;
      }

      return 0;
    },
    addCartItem(id) {
      const me = window.swinger.storage.get('me') || {};

      me.cart = me.cart || {};
      me.cart.items = me.cart.items || [];

      const alreadyInCart = !!me.cart.items.find((entry) => entry.id === id);

      if (alreadyInCart) {
        return;
      }

      const items = new Set(me.cart.items);

      items.add({
        id,
        type: window.swinger.config.client === 'dvdrotik' ? 'dvd' : 'vod',
      });

      me.cart.items = [...items.values()];

      window.swinger.storage.set('me', me);
    },
    removeCartItem(id) {
      const me = window.swinger.storage.get('me') || {};

      me.cart = me.cart || {};
      me.cart.items = (me.cart.items || []).filter((item) => `${item.id}` !== `${id}`);

      window.swinger.storage.set('me', me);
    },
    getItemLikedState(type, id) {
      const me = window.swinger.storage.get('me');

      return me && me.likedItems && me.likedItems[type] && me.likedItems[type].map((id) => `${id}`).indexOf(`${id}`) > -1;
    },
    setItemLikeState(type, id, newState) {
      const me = window.swinger.storage.get('me') || {};

      me.likedItems = me.likedItems || {};
      me.likedItems[type] = me.likedItems[type] || [];

      const likedIds = new Set(me.likedItems[type]);
      likedIds[newState ? 'add' : 'delete'](`${id}`);
      me.likedItems[type] = [...likedIds];

      window.swinger.storage.set('me', me);

      window.swinger.api.setItemLikeState(type, id, newState);
    },
    setDisplayMode(displayMode) {
      const me = window.swinger.storage.get('me') || { preferences: {} };

      me.preferences.displayMode = displayMode;
      window.swinger.storage.set('me', me);

      if (!window.swinger.user.isLoggedIn()) {
        return;
      }

      window.clearTimeout(apiTimers.setDisplayMode);
      apiTimers.setDisplayMode = window.setTimeout(() => {
        window.swinger.api.setDisplayMode(displayMode);
      }, 1000);
    },
    setItemOwnStateStarted(id) {
      id = `${id}`;
      const { 0: baseItemNumber } = id.split('-');

      const me = window.swinger.storage.get('me');
      const timestampNowSeconds = (new Date()).getTime() / 1000;
      const rentalHours = 48;
      const timeStampExpiresSeconds = timestampNowSeconds + (rentalHours * 3600);

      if (me.library && me.library[id] !== undefined && me.library[id] === null) {
        me.library[id] = {
          status: 'rented',
          rentalEndTimestamp: timeStampExpiresSeconds,
        };
      }

      if (me.library && me.library[baseItemNumber] !== undefined && me.library[baseItemNumber] === null) {
        me.library[baseItemNumber] = {
          status: 'rented',
          rentalEndTimestamp: timeStampExpiresSeconds,
        };
      }

      window.swinger.storage.set('me', me);
    },
    addItemToNotifications(id) {
      id = `${id}`;

      const me = window.swinger.storage.get('me') || {};

      me.watchedItems = me.watchedItems || [];

      const notificationIds = new Set(me.watchedItems);
      notificationIds.add(`${id}`);
      me.watchedItems = [...notificationIds];

      window.swinger.storage.set('me', me);
    },
    getAffiliateInfo() {
      const me = window.swinger.storage.get('me');

      return (me && me.affiliate) ? me.affiliate : {};
    },
  };

  window.swinger = window.swinger || {};
  window.swinger.user = { ...window.swinger.user, ...user };

  const showLoggedInSnackbar = () => {
    const me = window.swinger.storage.get('me');

    if (me && me.isConfirmed === false) {
      return;
    }

    if (window.swinger.user.isLoggedIn() && window.swinger.user.wasLoggedInOnPageLoad === false) {
      window.setTimeout(() => {
        window.swinger.i18n()
          .then((i18n) => {
            window.swinger.snackbar.create({
              isSelfclosing: true,
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'success',
                    text: i18n('ui.shared.login-successful'),
                  },
                },
              ],
            });
          })
          .catch(console.info);
      }, 2000);
      window.swinger.user.wasLoggedInOnPageLoad = true;
    } else if (!window.swinger.user.isLoggedIn() && window.swinger.user.wasLoggedInOnPageLoad === true) {
      window.swinger.user.wasLoggedInOnPageLoad = false;
    }
  };

  document.addEventListener('swinger.user:authchange', () => {
    showLoggedInSnackbar();
  });

  showLoggedInSnackbar();
})();
